(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["io-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var chips = root.querySelectorAll('[data-io-topic]');
      var grid = root.querySelector('[data-io-review-grid]');
      var status = root.querySelector('[data-io-review-status]');
      if (!chips.length || !grid) return;

      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-io-topics]'));

      function apply(topic) {
        var shown = 0;

        cards.forEach(function (card) {
          var topics = card.getAttribute('data-io-topics') || '';
          var match = !topic || topics.split(/[\s,]+/).indexOf(topic) !== -1;
          card.hidden = !match;
          if (match) shown++;
        });

        if (status) {
          status.textContent = topic
            ? shown + ' ulasan ditampilkan'
            : cards.length + ' ulasan ditampilkan';
        }
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var wasActive = chip.getAttribute('aria-pressed') === 'true';

          chips.forEach(function (other) {
            other.setAttribute('aria-pressed', 'false');
          });

          if (wasActive) {
            apply(null);
            return;
          }

          chip.setAttribute('aria-pressed', 'true');
          apply(chip.getAttribute('data-io-topic'));
        });
      });
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-io-reviews]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["io-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function setup(root) {
      var bar = root.querySelector('[data-io-sticky-bar]');
      if (!bar) return;

      var threshold = parseInt(root.getAttribute('data-show-after'), 10);
      if (isNaN(threshold)) threshold = 600;

      var shown = false;

      function update() {
        var past = window.scrollY > threshold;
        var atBottom =
          window.innerHeight + window.scrollY >= document.body.scrollHeight - 120;
        var next = past && !atBottom;

        if (next === shown) return;
        shown = next;

        if (next) {
          bar.hidden = false;
          requestAnimationFrame(function () {
            bar.classList.add('io-sticky--visible');
          });
          document.body.classList.add('io-has-sticky');
        } else {
          bar.classList.remove('io-sticky--visible');
          document.body.classList.remove('io-has-sticky');
        }
      }

      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update, { passive: true });
      update();
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-io-sticky]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["io-urgency-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function pad(n) {
      return n < 10 ? '0' + n : String(n);
    }

    function setup(root) {
      if (root.__ioTimer) clearInterval(root.__ioTimer);

      var raw = (root.getAttribute('data-end') || '').trim();
      if (!raw) return;

      var normalised = raw.replace(' ', 'T');
      if (!/[zZ]|[+-]\d{2}:?\d{2}$/.test(normalised)) normalised += '+07:00';

      var deadline = new Date(normalised).getTime();
      if (isNaN(deadline)) return;

      var hideExpired = root.getAttribute('data-hide-expired') === 'true';
      var out = {
        days: root.querySelector('[data-io-days]'),
        hours: root.querySelector('[data-io-hours]'),
        minutes: root.querySelector('[data-io-minutes]'),
        seconds: root.querySelector('[data-io-seconds]')
      };

      function tick() {
        var diff = deadline - Date.now();

        if (diff <= 0) {
          clearInterval(root.__ioTimer);
          if (hideExpired) {
            root.hidden = true;
            return;
          }
          diff = 0;
        }

        root.hidden = false;
        if (out.days) out.days.textContent = Math.floor(diff / 86400000);
        if (out.hours) out.hours.textContent = pad(Math.floor((diff % 86400000) / 3600000));
        if (out.minutes) out.minutes.textContent = pad(Math.floor((diff % 3600000) / 60000));
        if (out.seconds) out.seconds.textContent = pad(Math.floor((diff % 60000) / 1000));
      }

      tick();
      root.__ioTimer = setInterval(tick, 1000);
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-io-urgency]').forEach(setup);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () {
        init();
      });
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (event) {
      init(event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    /* Membuka = cukup men-set `open`; sisanya urusan CSS. Menutup butuh JS
       karena <details> membuang isinya SEKETIKA saat `open` dilepas — tidak
       ada yang tersisa untuk dianimasikan. Jadi atribut penanda dipasang
       dulu, `open` baru dilepas setelah transisinya benar-benar selesai.

       Tidak ada satu pun pembacaan geometri DOM di sini (scrollHeight,
       getBoundingClientRect) — itu yang dulu memaksa reflow sinkron dan
       membuat gerakannya tersendat di halaman sepanjang ini. */
    var CLOSING = 'lpClosing';

    function panel(item) {
      return item.querySelector('.lp-faq__a');
    }

    function collapse(item) {
      if (!item.open || item.dataset[CLOSING] !== undefined) return;
      var body = panel(item);
      if (!body) {
        item.open = false;
        return;
      }

      item.dataset[CLOSING] = '';

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        body.removeEventListener('transitionend', onEnd);
        delete item.dataset[CLOSING];
        item.open = false;
      }
      function onEnd(e) {
        if (e.target === body && e.propertyName === 'grid-template-rows') finish();
      }

      body.addEventListener('transitionend', onEnd);
      /* Jaring pengaman: kalau transisinya tidak pernah berbunyi (tab di
         latar belakang, prefers-reduced-motion, transisi dibatalkan),
         panelnya tetap harus tertutup — bukan tersangkut terbuka. */
      setTimeout(finish, 420);
    }

    function init(list) {
      if (list.dataset.lpFaqBound === 'true') return;
      list.dataset.lpFaqBound = 'true';

      var exclusive = list.hasAttribute('data-lp-faq-exclusive');

      list.addEventListener('click', function (event) {
        var summary = event.target.closest ? event.target.closest('summary') : null;
        if (!summary || !list.contains(summary)) return;

        var item = summary.parentElement;
        if (!item || item.tagName !== 'DETAILS') return;

        event.preventDefault();

        if (item.open) {
          collapse(item);
          return;
        }

        if (exclusive) {
          list.querySelectorAll('details[open]').forEach(collapse);
        }

        delete item.dataset[CLOSING];
        item.open = true;
      });
    }

    function start() {
      document.querySelectorAll('[data-lp-faq]').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-floating-cta"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function start() {
      var bar = document.querySelector('[data-lp-sticky-cta]');
      if (!bar) return;

      bar.removeAttribute('hidden');

      var trigger =
        document.querySelector('.lp-hero-section') ||
        document.querySelector('.lp-hero') ||
        document.querySelector('.lp-urgency-section');

      if (!trigger) {
        bar.classList.add('is-visible');
        return;
      }

      function syncHeight() {
        var visible = bar.classList.contains('is-visible');
        /* Bar disembunyikan dengan translateY, bukan display:none, jadi
           tingginya tetap terukur walau sedang tidak tampil. */
        var height = bar.getBoundingClientRect().height;
        var root = document.documentElement.style;
        root.setProperty('--lp-sticky-height', (visible ? height : 0) + 'px');
        root.setProperty('--lp-sticky-reserve', height + 'px');
      }

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            bar.classList.toggle('is-visible', !entry.isIntersecting);
            syncHeight();
          });
        },
        { threshold: 0 }
      ).observe(trigger);

      if (window.ResizeObserver) {
        new ResizeObserver(syncHeight).observe(bar);
      }
      window.addEventListener('resize', syncHeight);
      syncHeight();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASE = 'cubic-bezier(0.2, 0, 0, 1)';
    var BACK = 'cubic-bezier(0.34, 1.56, 0.64, 1)';
    var COUNT_DURATION = 3400;
    var SUFFIX_DURATION = 420;
    var START_SCALE = 0.72;

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function build(el) {
      var raw = el.dataset.lpCount || el.textContent || '';
      var parsed = raw.trim().match(/^(\D*?)([\d][\d.,\s\u00a0]*)(.*)$/);
      if (!parsed) return null;

      if (raw.indexOf(',') !== -1) return null;
      var digits = parsed[2].replace(/\D/g, '');
      var target = parseInt(digits, 10);
      if (!isFinite(target) || target < 1000) return null;

      el.textContent = '';
      if (parsed[1]) el.appendChild(document.createTextNode(parsed[1]));

      var value = document.createElement('span');
      value.className = 'lp-hero__count-value';
      value.textContent = target.toLocaleString('id-ID');
      el.appendChild(value);

      var suffix = null;
      if (parsed[3]) {
        suffix = document.createElement('span');
        suffix.className = 'lp-hero__count-suffix';
        suffix.textContent = parsed[3];
        el.appendChild(suffix);
      }

      var duration = parseInt(el.dataset.lpCountDuration, 10);
      if (!isFinite(duration) || duration < 200) duration = COUNT_DURATION;

      return { value: value, suffix: suffix, target: target, duration: duration };
    }

    function run(parts) {
      var value = parts.value;
      var target = parts.target;
      var final = target.toLocaleString('id-ID');

      value.style.minWidth = value.getBoundingClientRect().width + 'px';

      if (reducedMotion()) {
        value.textContent = final;
        return;
      }

      value.textContent = '0';
      if (parts.suffix) parts.suffix.style.opacity = '0';

      var growth = value.animate(
        [{ transform: 'scale(' + START_SCALE + ')' }, { transform: 'scale(1)' }],
        { duration: parts.duration, easing: EASE, fill: 'both' }
      );

      function tick() {
        var timing = growth.effect.getComputedTiming();
        var progress = timing.progress;
        if (progress === null || growth.playState === 'finished') {
          value.textContent = final;
          growth.cancel();
          return;
        }
        value.textContent = Math.round(target * progress).toLocaleString('id-ID');
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);

      if (parts.suffix) {
        var suffix = parts.suffix;
        var reveal = suffix.animate(
          [
            { opacity: 0, transform: 'translateY(14px)' },
            { opacity: 1, transform: 'none' }
          ],
          { duration: SUFFIX_DURATION, delay: parts.duration, easing: BACK, fill: 'both' }
        );
        reveal.finished.then(function () {
          reveal.cancel();
          suffix.style.opacity = '';
        }).catch(function () {});
      }
    }

    function init(el) {
      if (el.dataset.lpCountBound === 'true') return;
      el.dataset.lpCountBound = 'true';

      var parts = build(el);
      if (!parts) return;

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();
          run(parts);
        });
      }, { threshold: 0.6 });

      observer.observe(el);
    }

    function initGallery(root) {
      var stack = root.querySelector('[data-lp-gallery]');
      if (!stack || stack.dataset.lpGalleryBound === 'true') return;
      stack.dataset.lpGalleryBound = 'true';

      var slides = Array.prototype.slice.call(stack.querySelectorAll('[data-lp-slide]'));
      var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lp-thumb]'));
      if (slides.length < 2 || !thumbs.length) return;

      var current = 0;

      function show(index) {
        if (index === current || index < 0 || index >= slides.length) return;

        var from = slides[current];
        var to = slides[index];
        current = index;

        thumbs.forEach(function (thumb, i) {
          thumb.classList.toggle('is-active', i === index);
          thumb.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });

        if (reducedMotion()) {
          from.classList.remove('is-active');
          to.classList.add('is-active');
          return;
        }

        to.classList.add('is-active');
        to.animate(
          [
            { opacity: 0, transform: 'scale(1.03)' },
            { opacity: 1, transform: 'none' }
          ],
          { duration: 380, easing: EASE, fill: 'both' }
        ).finished.then(function () {
          to.getAnimations().forEach(function (a) { a.cancel(); });
        }).catch(function () {});

        var out = from.animate(
          [{ opacity: 1 }, { opacity: 0 }],
          { duration: 260, easing: EASE, fill: 'both' }
        );
        out.finished.then(function () {
          from.classList.remove('is-active');
          out.cancel();
        }).catch(function () {});
      }

      thumbs.forEach(function (thumb, index) {
        thumb.addEventListener('click', function () {
          show(index);
        });
        thumb.addEventListener('keydown', function (event) {
          var next = null;
          if (event.key === 'ArrowRight') next = index + 1;
          if (event.key === 'ArrowLeft') next = index - 1;
          if (next === null) return;
          event.preventDefault();
          next = (next + thumbs.length) % thumbs.length;
          thumbs[next].focus();
          show(next);
        });
      });
    }

    function initOffer(group) {
      if (group.dataset.lpOfferBound === 'true') return;
      group.dataset.lpOfferBound = 'true';
      if (reducedMotion()) return;

      var price = group.querySelector('.lp-hero__price');

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          observer.disconnect();

          group.animate(
            [
              { opacity: 0, transform: 'translateY(12px)' },
              { opacity: 1, transform: 'none' }
            ],
            { duration: 520, easing: EASE, fill: 'both' }
          ).finished.then(function () {
            group.getAnimations().forEach(function (a) { a.cancel(); });
          }).catch(function () {});

          if (price) {
            price.animate(
              [{ transform: 'scale(0.94)' }, { transform: 'none' }],
              { duration: 520, easing: EASE, fill: 'both' }
            ).finished.then(function () {
              price.getAnimations().forEach(function (a) { a.cancel(); });
            }).catch(function () {});
          }
        });
      }, { threshold: 0.35 });

      observer.observe(group);
    }

    function start() {
      document.querySelectorAll('[data-lp-count]').forEach(init);
      document.querySelectorAll('[data-lp-offer]').forEach(initOffer);
      document.querySelectorAll('.lp-hero__visual').forEach(initGallery);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-pricing"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function bind(group) {
      if (group.dataset.lpChoiceBound === 'true') return;
      var plan = group.closest('.lp-plan');
      if (!plan) return;
      var cta = plan.querySelector('[data-lp-plan-cta]');
      if (!cta) return;

      group.dataset.lpChoiceBound = 'true';

      group.addEventListener('change', function (event) {
        var radio = event.target;
        if (!radio || radio.type !== 'radio' || !radio.value) return;
        cta.setAttribute('href', radio.value);
      });

      var checked = group.querySelector('.lp-plan__radio:checked');
      if (checked && checked.value) cta.setAttribute('href', checked.value);
    }

    // Permalink keranjang membuat keranjang baru, jadi atribut apa pun yang
    // dipasang sebelum pindah halaman akan ikut terhapus. Penanda dititipkan di
    // sessionStorage lebih dulu, lalu snippet lp-only-guard menukarnya menjadi
    // atribut keranjang setelah pembeli mendarat di /cart.
    function stampSource() {
      var handle = (window.location.pathname.split('/pages/')[1] || '').split(/[/?#]/)[0];
      if (!handle) return;

      document.querySelectorAll('.lp-plan__cta').forEach(function (cta) {
        if (cta.dataset.lpStamped === 'true') return;
        cta.dataset.lpStamped = 'true';
        cta.addEventListener('click', function () {
          try {
            sessionStorage.setItem('lp_source', handle);
          } catch (e) {
            /* mode privat: penegakan sisi server tetap menjaga */
          }
        });
      });
    }

    function start() {
      document.querySelectorAll('[data-lp-plan-choice]').forEach(bind);
      stampSource();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  /* Penjaga stok produk utama (28 Sep 2026 — pesanan Rp0 #11056). Permalink
     keranjang langsung membuka checkout; bila produk utama tidak bisa dibeli,
     checkout Shopify membuangnya dan menyisakan hadiah Rp0. Maka tombol
     dinonaktifkan dengan label "Stok habis": dicek saat halaman dimuat, saat
     paket berganti (href berubah), dan SEKALI LAGI saat diketuk (real-time —
     halaman bisa tersaji dari cache berjam-jam). Produk utama = varian berharga
     > 0; hadiah (Rp0) diabaikan. Gagal jaringan = tetap lanjut, penjualan tidak
     boleh terblokir karena gangguan. */
  (function () {
    var root = document.querySelector('.lp-pricing[data-lp-soldout-label]');
    if (!root || root.dataset.lpStockGuard === 'true') return;
    root.dataset.lpStockGuard = 'true';
    var label = root.getAttribute('data-lp-soldout-label') || 'Sold out';
    var cache = {};

    function ids(href) {
      var part = (href || '').split('/cart/')[1];
      if (!part) return [];
      return part.split('?')[0].split(',').map(function (x) { return x.split(':')[0]; }).filter(Boolean);
    }
    function info(id, fresh) {
      if (!fresh && cache[id]) return cache[id];
      cache[id] = fetch('/variants/' + id + '.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { return j ? { price: j.price, available: j.available } : null; })
        .catch(function () { return null; });
      return cache[id];
    }
    /* true = semua produk utama bisa dibeli; false = ada yang habis; null = tidak diketahui */
    function mainAvailable(href, fresh) {
      var list = ids(href);
      if (!list.length) return Promise.resolve(true);
      return Promise.all(list.map(function (id) { return info(id, fresh); })).then(function (rs) {
        if (rs.some(function (r) { return r === null; })) return null;
        return rs.every(function (r) { return r.price === 0 || r.available; });
      });
    }
    function setState(a, ok) {
      if (ok === false) {
        if (a.dataset.lpSoldout !== 'true') a.dataset.lpLabel = a.innerHTML;
        a.innerHTML = label;
        a.dataset.lpSoldout = 'true';
        a.setAttribute('aria-disabled', 'true');
        a.style.opacity = '0.5';
        a.style.cursor = 'not-allowed';
      } else if (a.dataset.lpSoldout === 'true') {
        a.innerHTML = a.dataset.lpLabel || a.innerHTML;
        delete a.dataset.lpSoldout;
        a.removeAttribute('aria-disabled');
        a.style.opacity = '';
        a.style.cursor = '';
      }
    }
    function check(a, fresh) {
      return mainAvailable(a.getAttribute('href'), fresh).then(function (ok) { setState(a, ok); return ok; });
    }

    root.querySelectorAll('a[href*="/cart/"]').forEach(function (a) {
      check(a, false);
      new MutationObserver(function () { check(a, false); }).observe(a, { attributes: true, attributeFilter: ['href'] });
      a.addEventListener('click', function (e) {
        e.preventDefault();
        var href = a.getAttribute('href');
        check(a, true).then(function (ok) {
          if (ok === false) return;
          window.location.href = href;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-reviews"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var EASE = 'cubic-bezier(0.2, 0, 0, 1)';
    var DURATION = 520;

    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function init(scope) {
      var grid = scope.querySelector('[data-lp-reviews-grid]');
      if (!grid || grid.dataset.lpReviewsBound === 'true') return;
      grid.dataset.lpReviewsBound = 'true';

      var chips = Array.prototype.slice.call(scope.querySelectorAll('[data-lp-topic]'));
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.lp-review'));
      var empty = scope.querySelector('[data-lp-reviews-empty]');
      if (!chips.length || !cards.length) return;

      function matches(card, topic) {
        if (!topic) return true;
        return (card.dataset.lpReviewTopics || '').split(/[\s-]+/).indexOf(topic) !== -1;
      }

      chips.forEach(function (chip) {
        var hits = cards.filter(function (card) { return matches(card, chip.dataset.lpTopic); });
        if (!hits.length) chip.hidden = true;
      });

      function apply(topic) {
        cards.forEach(function (card) {
          card.getAnimations().forEach(function (a) {
            if (a.effect && a.effect.getKeyframes().some(function (k) { return 'transform' in k; })) a.cancel();
          });
        });

        var first = new Map();
        cards.forEach(function (card) {
          first.set(card, card.getBoundingClientRect());
        });

        var matched = cards.filter(function (card) { return matches(card, topic); });
        var rest = cards.filter(function (card) { return matched.indexOf(card) === -1; });

        if (empty) empty.hidden = matched.length > 0;

        matched.concat(rest).forEach(function (card) {
          grid.appendChild(card);
        });

        cards.forEach(function (card) {
          card.classList.toggle('is-muted', matched.indexOf(card) === -1);
        });

        if (reducedMotion()) return;

        cards.forEach(function (card) {
          var from = first.get(card);
          var to = card.getBoundingClientRect();
          var dx = from.left - to.left;
          var dy = from.top - to.top;
          if (!dx && !dy) return;
          card.animate(
            [
              { transform: 'translate(' + dx + 'px, ' + dy + 'px)' },
              { transform: 'none' }
            ],
            { duration: DURATION, easing: EASE }
          );
        });
      }

      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var wasActive = chip.getAttribute('aria-pressed') === 'true';
          chips.forEach(function (other) { other.setAttribute('aria-pressed', 'false'); });
          if (wasActive) {
            apply(null);
            return;
          }
          chip.setAttribute('aria-pressed', 'true');
          apply(chip.dataset.lpTopic);
        });
      });
    }

    function start() {
      document.querySelectorAll('.lp-reviews').forEach(init);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-testimonial-marquee"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reducedMotion() {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function settled() {
      var fonts = document.fonts && document.fonts.ready ? document.fonts.ready : Promise.resolve();
      return fonts.then(function () {
        return new Promise(function (resolve) {
          requestAnimationFrame(function () {
            requestAnimationFrame(resolve);
          });
        });
      });
    }

    function init(root) {
      var track = root.querySelector('[data-lp-marquee-track]');
      if (!track || root.dataset.lpMarqueeBound === 'true') return;
      if (reducedMotion()) return;

      var sets = Array.prototype.slice.call(track.querySelectorAll('[data-lp-marquee-set], .lp-tmarquee__set'));
      var cards = [];
      sets.forEach(function (set) {
        Array.prototype.slice.call(set.children).forEach(function (card) {
          cards.push(card);
        });
      });
      if (cards.length < 2) return;

      var gap = parseFloat(getComputedStyle(track).columnGap) || 0;

      var seconds = parseFloat(getComputedStyle(root).getPropertyValue('--lp-tmarquee-duration'));
      seconds = seconds > 0 ? seconds : 45;

      var perSet = 0;
      var setCount = sets.length || 1;
      cards.forEach(function (card) {
        perSet += card.offsetWidth + gap;
      });
      perSet = perSet / setCount;
      if (perSet < 40) return;

      var pxPerMs = perSet / (seconds * 1000);

      root.dataset.lpMarqueeBound = 'true';
      root.classList.add('is-interactive');

      sets.forEach(function (set) {
        set.remove();
      });
      cards.forEach(function (card) {
        card.removeAttribute('aria-hidden');
        track.appendChild(card);
      });

      var offset = 0;
      var last = 0;
      var running = false;
      var frameId = 0;
      var dragging = false;
      var lastX = 0;

      function recycle() {
        var guard = 0;
        var head = track.firstElementChild;
        while (head && guard < 60) {
          var width = head.offsetWidth + gap;
          if (-offset < width) break;
          offset += width;
          track.appendChild(head);
          head = track.firstElementChild;
          guard += 1;
        }

        guard = 0;
        var tail = track.lastElementChild;
        while (tail && offset > 0 && guard < 60) {
          var tailWidth = tail.offsetWidth + gap;
          track.insertBefore(tail, track.firstElementChild);
          offset -= tailWidth;
          tail = track.lastElementChild;
          guard += 1;
        }
      }

      function draw() {
        recycle();
        track.style.transform = 'translate3d(' + offset + 'px, 0, 0)';
      }

      function frame(now) {
        if (!running) return;
        if (!last) last = now;
        var delta = now - last;
        last = now;
        if (delta > 0 && delta < 200 && !dragging) {
          offset -= pxPerMs * delta;
        }
        draw();
        frameId = requestAnimationFrame(frame);
      }

      function play() {
        if (running || dragging) return;
        running = true;
        last = 0;
        frameId = requestAnimationFrame(frame);
      }

      function pause() {
        running = false;
        if (frameId) cancelAnimationFrame(frameId);
        frameId = 0;
      }

      draw();
      play();

      track.addEventListener('pointerdown', function (event) {
        if (event.button && event.button !== 0) return;
        dragging = true;
        lastX = event.clientX;
        root.classList.add('is-dragging');
        try { track.setPointerCapture(event.pointerId); } catch (e) {}
      });

      track.addEventListener('pointermove', function (event) {
        if (!dragging) return;
        event.preventDefault();
        offset += event.clientX - lastX;
        lastX = event.clientX;
        draw();
      });

      function release(event) {
        if (!dragging) return;
        dragging = false;
        root.classList.remove('is-dragging');
        try { track.releasePointerCapture(event.pointerId); } catch (e) {}
        last = 0;
      }

      track.addEventListener('pointerup', release);
      track.addEventListener('pointercancel', release);
      track.addEventListener('lostpointercapture', release);

      new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              play();
            } else {
              pause();
            }
          });
        },
        { rootMargin: '300px 0px' }
      ).observe(root);

      document.addEventListener('visibilitychange', function () {
        if (document.hidden) pause();
        else play();
      });

      window.addEventListener('pageshow', play);

      var remeasure;
      window.addEventListener('resize', function () {
        window.clearTimeout(remeasure);
        remeasure = window.setTimeout(function () {
          gap = parseFloat(getComputedStyle(track).columnGap) || 0;
          var total = 0;
          Array.prototype.slice.call(track.children).forEach(function (card) {
            total += card.offsetWidth + gap;
          });
          var next = total / setCount;
          if (next > 40) pxPerMs = next / (seconds * 1000);
          draw();
        }, 200);
      });
    }

    function start() {
      settled().then(function () {
        document.querySelectorAll('.lp-tmarquee').forEach(init);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }

    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-tokens"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function reveal() {
      var nodes = document.querySelectorAll('.lp-reveal:not(.is-visible)');
      if (!nodes.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        nodes.forEach(function (el) {
          el.classList.add('is-visible');
        });
        return;
      }

      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        },
        { threshold: 0.1 }
      );

      nodes.forEach(function (el) {
        observer.observe(el);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', reveal);
    } else {
      reveal();
    }

    document.addEventListener('shopify:section:load', reveal);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-urgency-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.lpCountdownReady) return;
    window.lpCountdownReady = true;

    function resolveDeadline(root) {
      var mode = root.dataset.mode;

      if (mode === 'fixed') {
        var parsed = Date.parse(root.dataset.deadline);
        if (!isNaN(parsed)) return parsed;
      }

      var hours = parseFloat(root.dataset.hours) || 48;
      var key = root.dataset.storageKey || 'lp-countdown';
      var stored = null;

      try {
        stored = window.localStorage.getItem(key);
      } catch (e) {
        stored = null;
      }

      var deadline = stored ? parseInt(stored, 10) : NaN;

      if (isNaN(deadline) || deadline <= Date.now()) {
        deadline = Date.now() + hours * 3600000;
        try {
          window.localStorage.setItem(key, String(deadline));
        } catch (e) {
          /* storage unavailable */
        }
      }

      return deadline;
    }

    function pad(value) {
      return value < 10 ? '0' + value : String(value);
    }

    function start() {
      var roots = document.querySelectorAll('[data-lp-countdown]');
      if (!roots.length) return;

      var timers = [];

      roots.forEach(function (root) {
        timers.push({
          deadline: resolveDeadline(root),
          days: root.querySelector('[data-lp-countdown-part="days"]'),
          hours: root.querySelector('[data-lp-countdown-part="hours"]'),
          minutes: root.querySelector('[data-lp-countdown-part="minutes"]'),
          seconds: root.querySelector('[data-lp-countdown-part="seconds"]')
        });
      });

      function tick() {
        timers.forEach(function (timer) {
          var diff = Math.max(0, timer.deadline - Date.now());
          var values = {
            days: Math.floor(diff / 86400000),
            hours: Math.floor((diff % 86400000) / 3600000),
            minutes: Math.floor((diff % 3600000) / 60000),
            seconds: Math.floor((diff % 60000) / 1000)
          };

          Object.keys(values).forEach(function (unit) {
            if (timer[unit]) timer[unit].textContent = pad(values[unit]);
          });
        });
      }

      tick();
      window.setInterval(tick, 1000);
    }

    function publishHeight() {
      var bar = document.querySelector('.lp-urgency-section');
      if (!bar) return;
      var sticky = getComputedStyle(bar).position === 'sticky';
      var height = sticky ? bar.getBoundingClientRect().height : 0;
      document.documentElement.style.setProperty('--lp-urgency-height', height + 'px');
    }

    function boot() {
      start();
      publishHeight();
      var bar = document.querySelector('.lp-urgency-section');
      if (bar && window.ResizeObserver) new ResizeObserver(publishHeight).observe(bar);
      window.addEventListener('resize', publishHeight);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
